<!-- Haupt-Tab „Konvertieren" (Route `/`): Upload, Einstellungen und Transformationen links, Vorschau, Konvertierung und Download rechts. Ohne Props. -->
<script setup lang="ts">
import {ref} from 'vue';
import {storeToRefs} from 'pinia';

import ConvertPanel from '@/components/ConvertPanel.vue';
import DownloadPanel from '@/components/DownloadPanel.vue';
import MeasureSelectionView from '@/components/measure-selection/MeasureSelectionView.vue';
import PartSelection from '@/components/PartSelection.vue';
import PreviewPane from '@/components/PreviewPane.vue';
import SettingsBasic from '@/components/settings/SettingsBasic.vue';
import TranspositionTabs from '@/components/transposition/TranspositionTabs.vue';
import UploadCard from '@/components/UploadCard.vue';
import {useIsMobile} from '@/composables/useIsMobile';
import {useSettingsStore} from '@/stores/settings';
import {useMusicUploadStore} from '@/stores/useMusicUploadStore.ts';

const conversionStore = useMusicUploadStore();
const {mode} = storeToRefs(useSettingsStore());
const {isHavingFile, previewFileContent} = storeToRefs(conversionStore);

// Auf mobilen Viewports (< md) starten Einstellungen + Transpositionen eingeklappt. Der
// Initialwert wird einmalig erfasst (nicht reaktiv an isMobile gebunden), damit manuelles
// Auf-/Zuklappen erhalten bleibt und ein Resize die Panels nicht erneut zuklappt.
const isMobile = useIsMobile();
const settingsExpanded = ref(false);
const transposeOpen = ref(!isMobile.value);

// Ein Handler für beide Wege zum Zurücksetzen der Arbeitsdatei (UploadCard „Datei entfernen",
// DownloadPanel „Erneut konvertieren").
function resetWorkingFile() {
  conversionStore.reset();
}
</script>

<template>
  <div class="grid gap-6 lg:grid-cols-[minmax(18rem,22rem)_minmax(0,1fr)] lg:items-stretch xl:grid-cols-[minmax(22rem,26rem)_minmax(0,1fr)]">

    <!-- Linke Sidebar -->
    <div class="min-w-0 space-y-4 lg:sticky lg:top-0 lg:self-start lg:max-h-[calc(100dvh-var(--header-h)-3rem)] lg:overflow-y-auto">
      <UploadCard @file-removed="resetWorkingFile" :variant="isHavingFile ? 'compact' : 'full'"/>
      <div class="flex flex-col gap-4 sm:flex-row sm:flex-wrap lg:flex-col">
        <SettingsBasic v-if="isHavingFile" class="flex min-h-0 flex-col shrink grow-1" v-model:expanded="settingsExpanded"/>

        <div v-if="isHavingFile" id="transposition-panel" class="flex min-h-0 flex-col grow-1 animate-fade-left animate-once animate-duration-500 animate-ease-in">
          <TranspositionTabs v-model:is-open="transposeOpen"/>
        </div>
      </div>
    </div>

    <!-- Rechte Hauptfläche: Modus + Stimmen + Preview + Download -->
    <div class="min-w-0 space-y-4 lg:border-l lg:border-gray-200 lg:pl-6 flex flex-col">
      <PartSelection/>
      <ConvertPanel v-if="isHavingFile"/>
      <MeasureSelectionView v-if="mode === 'per_measure'"/>
      <PreviewPane/>
      <DownloadPanel :visible="!!previewFileContent" @new-conversion="resetWorkingFile"/>
    </div>

  </div>
</template>
